<template>
  <header class="main-header flex-center-between">
    <img src="~@/assets/bd_rowa_rgb.png" height="24" class="logo" />
    <span class="mr-20">{{ user.firstName }} {{ user.lastName }}</span>
    <v-main-header-menu />
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import VMainHeaderMenu from "@/components/v-main-header-menu";

export default {
  name: "VMainHeader",
  components: {
    VMainHeaderMenu
  },
  computed: {
    ...mapGetters({
      user: "user/userDetails"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";

.main-header {
  padding: 0 24px;
  height: 64px;
  background: $color-lightgrey;
  font-size: 13px;
  .logo {
    margin-right: auto;
    margin-left: 0px;
  }
}

.separator {
  background: $color-grey;
  width: 2px;
  height: 40px;
}

.menu {
  width: 200px;
}
</style>
